import { useState, useEffect } from "react";
//components
import Panel from "../../../components/panel/panel";
import Select from "../../../components/input/Select";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import CalendarInput from "../../../components/input/CalendarInput";
import Input from "../../../components/input/Input";

// logos aqui truta
import logoItau from "../../../assets/banks/logo-itau.png";
import logoSicredi from "../../../assets/banks/icon-sicredi.png";
import logoBradesco from "../../../assets/banks/logo-bradesco.png";
import logoCaixa from "../../../assets/banks/logo-caixa.png";
import logoSantander from "../../../assets/banks/logo-santander.png";
import logoSicoob from "../../../assets/banks/banco-sicoob.png";
import logoBrasil from "../../../assets/banks/banco-do-brasil.png";
import logoSafra from "../../../assets/banks/banco-safra.png";
import logoWallet from "../../../assets/banks/logo-wallet.png";
import darkLogoWallet from "../../../assets/banks/logo-wallet-dark.png";

export default function FilterBank({
  form,
  accounts,
  isLoadingAccounts,
  loading,
  errors,
  onSyncClick,
  isButtonDisabled,
}) {
  const [filterType, setFilterType] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [startDate, setStartDate] = useState(null);

  const getDark = localStorage.getItem("appDarkMode");
  const [foto, setFoto] = useState(getDark === "true" ? logoWallet : darkLogoWallet);
  const [darkMode, setDarkMode] = useState(getDark === "true");
  useEffect(() => {
    if (getDark === "true") {
      setFoto(logoWallet);
      setDarkMode(true);
    } else {
      setFoto(darkLogoWallet);
      setDarkMode(false);
    }
  }, [getDark]);

  const LogoBanks = {
    "Banco Sicredi": logoSicredi,
    "Banco Itaú": logoItau,
    Itaú: logoItau,
    "Banco Bradesco": logoBradesco,
    Bradesco: logoBradesco,
    "Banco Caixa": logoCaixa,
    Caixa: logoCaixa,
    "Banco Santander": logoSantander,
    Santander: logoSantander,
    "Banco Sicoob": logoSicoob,
    Sicoob: logoSicoob,
    "Banco do Brasil": logoBrasil,
    "Banco Safra": logoSafra,
    Safra: logoSafra,
  "IB3 Capital": foto,
  };

  useEffect(() => {
    const subscription = form.watch((value) => {
      setFilterType(value.filterType || "");
      
      // Atualizar banco selecionado
      if (value.account_id && accounts) {
        const account = accounts.find(acc => acc.id === value.account_id);
        setSelectedBank(account?.bank || null);
      } else {
        setSelectedBank(null);
      }

      // Limpar data inicial quando não for filtro por período do Bradesco
      if (value.filterType !== "date" || selectedBank !== "237") {
        setStartDate(null);
      }
    });
    return () => subscription.unsubscribe();
  }, [form, accounts, selectedBank]);

  return (
    <Panel title="Sincronização Bancária">
      <div className="row align-items-end">
        <div className="col-xl-4 mb-3">
          <Select
            name="account_id"
            label={isLoadingAccounts ? "Carregando..." : "Conta Bancária *"}
            control={form.control}
            errors={errors}
            disabled={isLoadingAccounts || loading}
            isRequired={true}
            options={
              accounts &&
              accounts.map((account) => {
                return {
                  value: account.id,
                  label: `${account.nameCompany} | ${account.name_bank} | Conta: ${account.account_number} | Agência: ${account.agency}`,
                  logo: LogoBanks[account.name_bank] || null,
                };
              })
            }
            itemTemplate={(option) =>
              option ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {option.logo && (
                    <img
                      src={option.logo}
                      alt={option.label}
                      style={{
                        width: 24,
                        height: 24,
                        marginRight: 8,
                        objectFit: "contain",
                      }}
                    />
                  )}
                  <span>{option.label}</span>
                </div>
              ) : null
            }
          />
        </div>
        
        <div className="col-xl-4 mb-3">
          <div className="d-flex gap-3 align-items-center">
            <div className="">
              <RadioButton
                inputId="date"
                name="filterType"
                value="date"
                checked={filterType === "date"}
                onChange={(e) => {
                  setFilterType(e.value);
                  form.setValue("filterType", e.value);
                }}
              />
              <label htmlFor="date" className="mx-2">
                {selectedBank === "237" ? "Filtrar por Período" : "Filtrar por Data De Baixa"}
              </label>
            </div>
            <div className="">
              <RadioButton
                inputId="our_number"
                name="filterType"
                value="our_number"
                checked={filterType === "our_number"}
                onChange={(e) => {
                  setFilterType(e.value);
                  form.setValue("filterType", e.value);
                }}
              />
              <label htmlFor="our_number" className="mx-2">
                Filtrar por Número de Parcela
              </label>
            </div>
          </div>
        </div>

        <div className="col-xl-4 mb-3">
          {filterType === "date" && selectedBank === "237" && (
            <div>
              <div className="row">
                <div className="col-6">
                  <CalendarInput
                    name="start_date"
                    label="Data Inicial *"
                    control={form.control}
                    errors={errors}
                    isRequired={true}
                    disabled={loading}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                  />
                </div>
                <div className="col-6">
                  <CalendarInput
                    name="end_date"
                    label="Data Final *"
                    control={form.control}
                    errors={errors}
                    isRequired={true}
                    disabled={loading}
                    minDate={startDate}
                    maxDate={startDate ? new Date(startDate.getTime() + 7 * 24 * 60 * 60 * 1000) : null}
                  />
                </div>
              </div>
              
            </div>
          )}

          {filterType === "date" && selectedBank !== "237" && (
            <CalendarInput
              name="date"
              label="Data de baixa *"
              control={form.control}
              errors={errors}
              isRequired={true}
              disabled={loading}
            />
          )}

          {filterType === "our_number" && (
            <Input
              name="our_number"
              label="Número da Parcela *"
              control={form.control}
              errors={errors}
              isRequired={true}
              disabled={loading}
              className="w-100"
            />
          )}
        </div>
       
       

        <div className="col-12 d-flex justify-content-end align-items-end mb-3 mt-3">
          <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
            <Button
              label="Sincronizar"
              icon="pi pi-sync"
              loading={loading}
              className="w-100"
              onClick={onSyncClick}
              disabled={isButtonDisabled()}
              tooltip={
                isButtonDisabled()
                  ? "Selecione uma conta e um tipo de filtro para sincronizar"
                  : ""
              }
              tooltipOptions={{ position: "top" }}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
}
